import storage from '@base/utils/storage'
import { LOCALSTORAGE_TOKENINFO, MEMBER_TYPE } from '@r/page/src/config'
import { isMiniProgram, isSunriseClient } from '@r/page/src/utils/browser'
import { getUniversalUrls } from '.'
import { ClientInstance } from './jsbridge'

const LOGIN_PAGE = '/pages/main/my/login/index'
const LOGIN_MOBILE_PAGE = '/pages/main/my/mobile-bind/index'
const BACK_URL = encodeURIComponent(window.location.href)

const locking: Record<string, boolean> = {
  login: false,
  getUserInfo: false,
}

export const redirectLogin = (cb: () => void) => {
  console.log('locking', locking)
  if (locking.login) return

  locking.login = true

  if (isSunriseClient) {
    window.sr.client.login({
      success(res) {
        console.log('resLogin', res)

        setUserInfo(generateUserInfoStruct(res)).then(() => {
          console.log('cb', cb)
          cb && cb()
        })
      },
      fail(res) {
        // toast.error('登陆失败，请稍后重试')
        locking.login = false
      },
      complete() {
        console.log('locking complete')
        locking.login = false
      },
    })

    return
  }

  if (isMiniProgram) {
    window.sr.router.push({
      urls: {
        mini: LOGIN_PAGE,
      },
      query: {
        backUrl: BACK_URL,
      },
    })

    setTimeout(() => (locking.login = false), 3000)

    return
  }

  window.sr.router.push({
    urls: getUniversalUrls({ mini: LOGIN_MOBILE_PAGE }),
    query: {
      backUrl: BACK_URL,
    },
  })
}

export type UserInfoStruct = {
  tokenInfo: {
    accessToken: string
  }
  userId: string
  srCode: string
  openId: string
  mobile?: string
  isLogin: boolean
}

export type Callbacks = {
  success: (userInfo: UserInfoStruct) => void
  fail: (userInfo: UserInfoStruct) => void
  complete: () => void
}

export function setUserInfo<T>(userInfo: T): Promise<T> {
  return new Promise((r, j) => {
    // @ts-ignore
    window.sr.userInfo = userInfo

    storage.set(LOCALSTORAGE_TOKENINFO, userInfo)

    r(userInfo)
  })
}

export function generateUserInfoStruct(res: Partial<UserInfoStruct> & { memberList?: any[] }): UserInfoStruct {
  let srCode: string

  if (res?.memberList?.length) {
    srCode = res.memberList.find((item) => item.memberType === MEMBER_TYPE.sunrise).memberCode
  }

  return {
    tokenInfo: res.tokenInfo,
    userId: res?.userId,
    srCode: srCode,
    openId: res?.openId,
    mobile: res?.mobile,
    isLogin: res.isLogin,
  }
}

export function getUserInfoFromClient(client: ClientInstance, cbs: Partial<Callbacks> = {}): Promise<UserInfoStruct> {
  if (locking.getUserInfo) return Promise.resolve({} as UserInfoStruct)

  locking.getUserInfo = true

  const { success, fail, complete } = cbs

  return new Promise((resolve, reject) => {
    let userInfo = {
      isLogin: false,
    } as UserInfoStruct

    const completeHandler = () => {
      locking.getUserInfo = false
      complete && complete()
    }

    client.getUserInfo({
      success(res) {
        console.log('resUserInfo', res)
        userInfo = generateUserInfoStruct({
          ...res,
          isLogin: true,
        })

        setUserInfo(userInfo).then((userInfo) => success && success(userInfo))

        resolve(userInfo)
      },
      fail() {
        client.getToken({
          success: (res: { accessToken: string; userId: string; isLogin: boolean }) => {
            console.log('resGetToken', res)

            userInfo = generateUserInfoStruct({
              tokenInfo: {
                accessToken: res?.accessToken,
              },
              userId: res?.userId,
              isLogin: res.isLogin,
            })

            setUserInfo(userInfo).then((userInfo) => success && success(userInfo))

            resolve(userInfo)
          },
          fail: () => {
            setUserInfo(userInfo).then(fail)
            resolve(userInfo)
          },
          complete: completeHandler,
        })
      },
      complete: completeHandler,
    })
  })
}

export function getUserInfoByUrl(params): Promise<UserInfoStruct> {
  return new Promise((resolve, reject) => {
    const userId = params.get('userId')
    const accessToken = params.get('accessToken')
    const srCode = params.get('rsCode')
    const openId = params.get('openId')
    const mobile = params.get('mobile')
    const status = params.get('status')

    const userInfo = generateUserInfoStruct({
      userId: userId,
      tokenInfo: { accessToken },
      srCode: srCode,
      openId: openId,
      mobile: mobile,
      isLogin: !!(status * 1),
    })

    setUserInfo(userInfo)
    resolve(userInfo)
  })
}

export function getUserInfo({ client, location }): Promise<UserInfoStruct> {
  return isSunriseClient ? getUserInfoFromClient(client) : getUserInfoByUrl(location)
}

export function getCurrentUser() {
  return window.sr?.userInfo || storage.get<UserInfoStruct>(LOCALSTORAGE_TOKENINFO)
}
